import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";
import Timeline = gsap.Timeline;

export class TractorBeamRandFeatureEvent {
    public static readonly ADD_NEXT_SYMBOL:string = "tractorBeamRandFeatureEvent_addNextSymbol";
    public static readonly ANIMATE_RANDOM_SYMBOL:string = "tractorBeamRandomFeatureEvent_animateRandomSymbol";
    public static readonly RESET_REEL_SPEED:string = "tractorBeamRandFeatureEvent_resetReelSpeed";
    public static readonly SHUFFLE_CURRENT_REEL_SET:string = "tractorBeamRandFeatureEvent_shuffleCurrentReelSet";
    public static readonly ADD_RANDOM_SYMBOL_TO_REEL:string = "tractorBeamRandFeatureEvent_addRandomSymbolToReel";
    public static readonly REMOVE_RANDOM_SYMBOL_TO_REEL:string = "tractorBeamRandFeatureEvent_removeRandomSymbolToReel";
    public static readonly RANDOM_SYMBOL_POSITION:string = "tractorBeamRandFeatureEvent_randomSymbolPosition";
    public static readonly RANDOM_SYMBOL_LANDED:string = "tractorBeamRandFeatureEvent_randomSymbolLanded"
}

export class TractorBeamRandomFeatureController extends BaseController{
    protected _gameData:ParsedGameData | null;
    private _randomFeatureTriggered:boolean = false;
    private _randomStackTriggered:boolean = false;
    private _removedSymbols:string[];
    private _animatedSymbols:{reelId:number}[];
    private _reelIDArray:number[] = [0,1,2,3,4];
    private _landedSymbolsCount = 0;
    private _quickStop:boolean = false;
    private _aborted:boolean = false;
    private _randomSymbolsLength:number = 0;

    private _featureTextTimeline:Timeline | null;
    private _featurePlayed:boolean = false;

    constructor(){
        super();
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.ANIMATE_RANDOM_SYMBOL, (event:GameEvent) => this.animateRandomSymbol(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.ADD_NEXT_SYMBOL, (event:GameEvent) => this.addSymbolToReel(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => this.onBeforeSpinStart());
        //EventHandler.addEventListener(this, SpinEvent.SKIP, (event:SpinEvent) => this.onSkip());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:SpinEvent) => this.onSpinStopped())
    }

    private onBeforeSpinStart():void{
        this._featurePlayed = false;
        this._animatedSymbols = [];
        this._reelIDArray = [0,1,2,3,4];
        this._quickStop = false;
    }

    private addSymbolToReel(reelId:number, symName:string, quickStop:boolean):void{
        if(this._reelIDArray.indexOf(reelId) > -1){
            this._reelIDArray.splice(this._reelIDArray.indexOf(reelId), 1);
            EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.RANDOM_SYMBOL_POSITION, reelId));
        }
        this._quickStop = quickStop;
        EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.REMOVE_RANDOM_SYMBOL_TO_REEL, reelId));
    }

    private animateRandomSymbol(reelId:number, symbols:StateReelSymbol[]){
        this._animatedSymbols.push({reelId: reelId});
        TractorBeamGameModuleConfig.tractorBeamRandomFeatureView.createRandomSymbol(reelId, symbols, this._quickStop, this._animatedSymbols.length === TractorBeamGameConfig.instance.REELS_NUM);
        if(this._animatedSymbols.length === TractorBeamGameConfig.instance.REELS_NUM){

            let randomSymbolAnimTimeLine: TimelineLite = new TimelineLite({onComplete: () => {
                    randomSymbolAnimTimeLine.pause();
                    randomSymbolAnimTimeLine.kill();
                }});
                randomSymbolAnimTimeLine.delay((this._quickStop)? 2 : 2);
                randomSymbolAnimTimeLine.call(() => EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP)));
            this._animatedSymbols = [];
        }
    }


    private onGameDataParsed(data:TractorBeamParsedGameData):void {
        this._aborted = false;
        TractorBeamGameModuleConfig.tractorBeamRandomFeatureView.hasPlayed = false;
        this._gameData = data;
        this._randomFeatureTriggered = data.isRandomFeature;
        this._randomStackTriggered = data.randomStackedTriggered;
        this._removedSymbols = data.removedSymbols;
        this._randomSymbolsLength = this._removedSymbols.length;
        //console.log(this._randomSymbolsLength);
        if(data.isRandomFeature || data.randomStackedTriggered) {
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.ADD_STOP_DELAY, this.getSpinDelay()));
        }
    }

    private getSpinDelay():number{
        const symCount = this._removedSymbols.length;

        if(this._randomStackTriggered) {
            // TODO: fugly timeline!
            if(!this._featurePlayed) {
                this._featurePlayed = true;
                this._featureTextTimeline = new TimelineLite().add(TractorBeamGameModuleConfig.tractorBeamRandomStacks.playRandomFeature(true), 1.2);
                this._featureTextTimeline.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
                }, 3.4);
                /*if(!this._aborted && !this._quickStop) {
                    this._featureTextTimeline.add(() => {
                        if (!this._aborted && !this._quickStop) {
                            //TractorBeamGameModuleConfig.reelAttention.tryPlayAttentionReelZero(); // TODO: Most likely obsolete
                        }
                    }, 3.6);
                }*/
            }
            return 2.1;
        }
        else {
            if(!this._featurePlayed && this._randomFeatureTriggered) {
                this._featurePlayed = true;
                this._featureTextTimeline = new TimelineLite().add(TractorBeamGameModuleConfig.tractorBeamRandomStacks.playRandomFeature(), 0.7);
            }
            return (symCount * 50) - TractorBeamGameConfig.instance.REEL_SPIN_TIME * 4;
        }
    }

    private onSpinStopped():void {
        this._aborted = true;
        //console.log("Spin stopped!");
        if(this._featureTextTimeline) {
            //this._featureTextTimeline.progress(1);
        }
    }

    public onSkip():void {
        this._aborted = true;

        if(this._featureTextTimeline) {

            if(this._randomStackTriggered) {
                this._featureTextTimeline.pause(0);

                this._featureTextTimeline.timeScale(8);
                this._featureTextTimeline.play();
                this._featureTextTimeline.progress(0.6);
            }
            if(this._randomFeatureTriggered) {
                this._featureTextTimeline.progress(1);
            }
        }
    }

}
